import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Button,
  Tab,
  Tabs,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <>{children}</>}
    </div>
  );
}

interface CommissionData {
  milestones: Record<string, number>;
  categories: Record<string, number>;
}

const ManageCommission: React.FC = () => {
  const navigate = useNavigate();
  const [mainTab, setMainTab] = useState(0);

  const [commissions, setCommissions] = useState<
    Record<string, CommissionData>
  >({
    salaried: {
      milestones: { milestone1: 2, milestone2: 2, milestone3: 2 },
      categories: { study: 10, business: 5, tourist: 7, work: 10 },
    },
    freelancer: {
      milestones: { milestone1: 3, milestone2: 3, milestone3: 3 },
      categories: { study: 8, business: 6, tourist: 5, work: 10 },
    },
    companies: {
      milestones: { milestone1: 4, milestone2: 4, milestone3: 4 },
      categories: { study: 9, business: 7, tourist: 6, work: 10 },
    },
  });

  const handleChange = (
    tab: string,
    type: "milestones" | "categories",
    key: string,
    value: string
  ) => {
    setCommissions((prev) => ({
      ...prev,
      [tab]: {
        ...prev[tab],
        [type]: { ...prev[tab][type], [key]: Number(value) },
      },
    }));
  };

  const tabKeys = ["salaried", "freelancer", "companies"];
  const tabLabels = ["Salaried Agents", "Freelancer Agents", "Companies"];

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Commissions</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          Commissions
        </p>
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <Tabs
            value={mainTab}
            onChange={(_, newValue) => setMainTab(newValue)}
            className="custom_tabs_links"
          >
            {tabLabels.map((label, index) => (
              <Tab key={index} label={label} />
            ))}
          </Tabs>

          {tabKeys.map((tab, index) => (
            <CustomTabPanel key={tab} value={mainTab} index={index}>
              <TableContainer component={Paper} sx={{ mt: 3 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ minWidth: "120px" }}>
                        Visa Type
                      </TableCell>
                      <TableCell>Commission (%)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.keys(commissions[tab].categories).map(
                      (category) => (
                        <TableRow key={category}>
                          <TableCell>
                            {category.charAt(0).toUpperCase() +
                              category.slice(1)}
                          </TableCell>
                          <TableCell>
                            <TextField
                              type="number"
                              value={commissions[tab].categories[category]}
                              onChange={(e) =>
                                handleChange(
                                  tab,
                                  "categories",
                                  category,
                                  e.target.value
                                )
                              }
                            />
                          </TableCell>
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TableContainer component={Paper} sx={{ mt: 3 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ minWidth: "120px" }}>
                        Milestone
                      </TableCell>
                      <TableCell>Commission (%)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.keys(commissions[tab].milestones).map(
                      (milestone) => (
                        <TableRow key={milestone}>
                          <TableCell>
                            {milestone.replace("milestone", "Milestone ")}
                          </TableCell>
                          <TableCell>
                            <TextField
                              type="number"
                              value={commissions[tab].milestones[milestone]}
                              onChange={(e) =>
                                handleChange(
                                  tab,
                                  "milestones",
                                  milestone,
                                  e.target.value
                                )
                              }
                            />
                          </TableCell>
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </CustomTabPanel>
          ))}
        </Box>

        {/* Save Button */}
        <Box mt={3} textAlign="right">
          <Button variant="contained" color="primary" onClick={() => {}}>
            Save Changes
          </Button>
        </Box>
      </div>
    </MainContainer>
  );
};

export default ManageCommission;
